<mat-dialog-content>
  @if (advancedCommands && advancedCommands.length > 0) {
    <mat-list>
      @for (command of advancedCommands; track $index) {
        <mat-list-item class="text-align">
          <span matLine>{{ command.displayName }}</span>
          <button mat-icon-button (click)="sendAdvancedCommand(command)">
            <mat-icon>{{ iconMap[command.displayName] }}</mat-icon>
          </button>
        </mat-list-item>
      }
    </mat-list>
  } @else if (advancedCommands?.length === 0) {
    <div>No Commands Are Available</div>
  }
</mat-dialog-content>
<mat-dialog-actions flexLayoutAlign="end">
  <button mat-flat-button [mat-dialog-close]>Close</button>
</mat-dialog-actions>
